<style scoped>

</style>
<template>
	<div>
		<!-- <Row class="expand-row">
            <Col span="4">
                <span class="expand-key">充电开始时间: </span>
                <span class="expand-value">{{ row.ChargeStartTime }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">充电启动方式: </span>
                <span class="expand-value">{{ row.StartMode }}</span>
            </Col>
            <Col span="4">
                <span class="expand-key">充电电压: </span>
                <span class="expand-value">{{ row.ChargeVoltage }}</span>
            </Col>
			<Col span="4">
			    <span class="expand-key">充电电流: </span>
			    <span class="expand-value">{{ row.ChargeCurrent }}</span>
			</Col>
			<Col span="4">
			    <span class="expand-key">充电时长: </span>
			    <span class="expand-value">{{ row.ChargeDuration }}</span>
			</Col>
			<Col span="4">
			    <span class="expand-key">充电功率: </span>
			    <span class="expand-value">{{ row.ChargePower }}</span>
			</Col>
        </Row> -->
		<Row class="expand-row">
			<Col span="4">
			<span class="expand-key">设备编号: </span>
			<span class="expand-value">{{ row.EquipmentNo }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">设备名称: </span>
			<span class="expand-value">{{ row.EquipmentName }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">枪编号: </span>
			<span class="expand-value">{{ row.ConnectorNo }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">枪名称: </span>
			<span class="expand-value">{{ row.ConnectorName }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">设备类型: </span>
			<span class="expand-value">{{ row.EquipmentTypeDesc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">枪类型: </span>
			<span class="expand-value">{{ row.ConnectorTypeDesc }}</span>
			</Col>
			<!-- <Col span="4">
			    <span class="expand-key">已充电量: </span>
			    <span class="expand-value">{{ row.ChargeKwh }}</span>
			</Col>
			<Col span="4">
			    <span class="expand-key">已充费用: </span>
			    <span class="expand-value">{{ row.ChargeCost }}</span>
			</Col>
			
			<Col span="4">
			    <span class="expand-key">当前SOC: </span>
			    <span class="expand-value">{{ row.CurrentSoc }}</span>
			</Col>
			<Col span="4">
			    <span class="expand-key">剩余时长: </span>
			    <span class="expand-value">{{ row.RemainDuration }}</span>
			</Col> -->
			<Col span="4">
			<span class="expand-key">工作状态: </span>
			<span class="expand-value">{{ row.WorkStatusDesc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">最高告警码: </span>
			<span class="expand-value">{{ row.MaxAlarmDesc }}</span>
			</Col>

			<Col span="4">
			<span class="expand-key">连接状态: </span>
			<span class="expand-value">{{ row.CarCoupleStatusDesc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">额定功率(KW): </span>
			<span class="expand-value">{{ row.RatedPower }}</span>
			</Col>
			<!-- <Col span="4">
			<span class="expand-key">会员名称: </span>
			<span class="expand-value">{{ row.MemberName }}</span>
			</Col> -->
			<!-- <Col span="4">
			<span class="expand-key">手机号码: </span>
			<span class="expand-value">{{ row.MemberPhone }}</span>
			</Col> -->
			<Col span="4">
			<span class="expand-key">BMS需求电压(V): </span>
			<span class="expand-value">{{ row.BmsDemandVoltage }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">BMS需求电流(A): </span>
			<span class="expand-value">{{ row.BmsDemandCurrent }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">电池温度(℃): </span>
			<span class="expand-value">{{ row.BatteryTemp }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">枪温度(℃): </span>
			<span class="expand-value">{{ row.ConnectorTemp }}</span>
			</Col>
		</Row>
		<Row class="expand-row">
			<Col span="6">
			<span class="expand-key">汽车VIN码: </span>
			<span class="expand-value">{{ row.VIN }}</span>
			</Col>
			<Col span="6">
			<span class="expand-key">充电卡编号: </span>
			<span class="expand-value">{{ row.CardNo }}</span>
			</Col>
		</Row>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		}
	};
</script>
